import { Map } from '@cian/frontend-newbuilding-map-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { useMapsFitToViewport } from './hooks/useMapsFitToViewport';
import { CardSection } from '../../components/CardSection';
import { MapWrapper } from '../../components/MapWrapper';
import { VisibilityController } from '../../components/VisibilityController';
import { OfferMapGeoContainer } from '../../components/map/geo/container';
import { OfferMapTabsContainer } from '../../components/map_tabs/container';
import { MAP_CONTAINER_ID } from '../../constants/map';
import { offerSelector, selectGeoCoordinates, selectIsOfferPageRedesign } from '../../selectors';
import { selectIsRouteMapTabEnabled } from '../../selectors/selectIsRouteMapTabEnabled';
import { selectMapTabs } from '../../selectors/selectMapTabs';
import { MapTab } from '../../store/map_tabs';
import { getOfferType, isCommercial } from '../../utils/offer_type';
import { MapLoadable } from '../MapContainer';
import { PanoramaBannerContainer } from '../PanoramaBannerContainer';
import { PanoramaContainer } from '../PanoramaContainer';
import { RouteMapLoadable } from '../RouteMapContainer/RouteMapLoadable';

export const MapsSectionContainer = () => {
  const { activeTab } = useSelector(selectMapTabs);
  const isRouteMapEnabled = useSelector(selectIsRouteMapTabEnabled);
  const offer = useSelector(offerSelector);
  const pinCoordinates = useSelector(selectGeoCoordinates);
  const isRedesignPage = useSelector(selectIsOfferPageRedesign);

  const offerType = getOfferType(offer);
  const isRouteMapTabActive = activeTab === MapTab.routeMap;

  const routeMapRef = React.useRef<Map>(null);
  const mapRef = React.useRef<YMaps.Map>();
  /* istanbul ignore next */
  const setMapRef = React.useCallback((map: YMaps.Map) => (mapRef.current = map), []);

  useMapsFitToViewport({ routeMapRef, mapRef, isRouteMapTabActive });

  if (!pinCoordinates) {
    return null;
  }

  return (
    <CardSection id={MAP_CONTAINER_ID} redesign={isRedesignPage}>
      {isCommercial(offerType) && <OfferMapGeoContainer />}
      <OfferMapTabsContainer />
      <MapWrapper fixedHeight={isRouteMapEnabled}>
        {isRouteMapEnabled && (
          <VisibilityController isVisible={isRouteMapTabActive}>
            <RouteMapLoadable mapRef={routeMapRef} />
          </VisibilityController>
        )}
        <VisibilityController isVisible={!isRouteMapTabActive}>
          <MapLoadable mapRef={setMapRef} />
        </VisibilityController>
      </MapWrapper>
      <PanoramaBannerContainer>
        <PanoramaContainer />
      </PanoramaBannerContainer>
    </CardSection>
  );
};
